<script setup>
import { computed } from 'vue';
import { useRoute, RouterLink } from 'vue-router';

const props = defineProps({
  routerLink: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
});

const route = useRoute();

const isActive = computed(() => {
  return route.name === props.routerLink;
});

defineExpose({
  props,
});
</script>
<template>
  <ul class="navigation m-0 p-0 menu-item-navigation">
    <li class="nav-item m-0 menu-item" :class="{active: isActive}">
      <router-link :to="{name: routerLink}" class="d-flex align-items-center px-0 m-0">
        <i class="fa-regular fa-circle mx-1 menu-item-icon"></i>
        <span class="menu-title text-truncate">{{ props.title }}</span>
      </router-link>
    </li>
  </ul>
</template>
<style scoped>
.menu-item.active {
  background: none;
  box-shadow: none;
}

.menu-item.active>a {
  background-color: rgba(115, 103, 240, 0.12);
  color: #FFF;
  border-radius: 4px;
}

.menu-item.active>a>i {
  color: #FFF;
}

.menu-item-icon {
  margin-bottom: 5px;
}

.menu-item-icon::before {
  font-size: 1rem;
}

.menu-item {
  width: 230px;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .menu-item .menu-title {
  height: 0px;
  visibility: hidden;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu.expanded .menu-item .menu-title {
  height: auto;
  visibility: visible;
}
</style>
